import OpDecisionSection from './OpDecisionSection';

export default OpDecisionSection;
